var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('drawer',{attrs:{"dismissRoute":'/user/address_book/'}},[_c('div',{staticClass:"drawer-title"},[_c('i',{staticClass:"mat-icon"},[_vm._v("add_circle")]),_vm._v("New Contact"),_c('contact-builder',{attrs:{"displaySave":true,"loading":_vm.loading},on:{"saveClick":_vm.createContact}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-721e49c0","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/user/ContactsNew.vue
// module id = 693
// module chunks = 0